<template>
  <!-- 骨架屏 -->
  <div v-if="pageLoading" style="padding-top: 80px">
    <van-skeleton title :row="5" />
    <van-skeleton title :row="5" style="margin-top: 30px" />
  </div>
  <div v-else class="new-customer-gift">
    <!-- 权益列表 -->
    <div class="benefit-list">
      <div class="claim-tip">活动期间<span>仅可领取1次</span></div>
      <div
        class="benefit-item"
        v-for="(benefit, index) in benefitList"
        :key="index"
      >
        <!-- 标题图片 -->
        <div class="benefit-title-img-wrapper">
          <img
            :src="benefit.titleImg"
            :alt="benefit.title"
            class="benefit-title-img"
          />
        </div>

        <!-- 数字商品：4列小卡片 -->
        <div class="digital-items-grid">
          <div
            class="digital-card"
            v-for="(option, optIndex) in benefit.digitalOptions"
            :key="'digital-' + optIndex"
          >
            <div class="card-header-tag">{{ option.name }}</div>
            <img :src="option.img" :alt="option.name" class="card-img" />
            <div class="card-price-tag">{{ option.price }}</div>
          </div>
        </div>

        <!-- 实物商品：2列宽卡片 -->
        <div class="physical-items-grid">
          <div
            class="physical-card"
            v-for="(option, optIndex) in benefit.physicalOptions"
            :key="'physical-' + optIndex"
          >
            <div class="card-header-tag physical-tag">{{ option.name }}</div>
            <div class="physical-content">
              <div class="physical-desc">{{ option.price }}</div>
              <img :src="option.img" :alt="option.name" class="physical-img" />
            </div>
          </div>
        </div>
        <!-- 领取按钮 -->
        <div class="claim-btn" @click="handleClaim(benefit)">{{ benefit.buttonText }}</div>
      </div>
    </div>

    <!-- 活动规则，领取记录 -->
    <ul class="benefit-info">
      <li class="rule" @click="ruleVisible = true"></li>
      <li class="record" @click="recordVisible = true"></li>
      <li class="share" @click="goShare"></li>
    </ul>

    <ruleModal :visible="ruleVisible" @confirm="ruleVisible = false" />
    <confirmModal
      :visible="confirmVisible"
      :confirmIsPopup="confirmIsPopup"
      @confirm="onConfirmClaim"
      @cancel="confirmVisible = false"
    />
    <rewordModal
      :userRightsLevel="userRightsLevel"
      :visible="rewordVisible"
      :userRightsToken="userRightsToken"
      @confirm="
        ;(rewordVisible = false), luyuanNewCustomerQueryActivityDetail()
      "
      @close="rewordVisible = false"
    />
    <recordModal :visible="recordVisible" @confirm="recordVisible = false" />
    <tipModal
      :visible="tipVisible"
      :message="tipMessage"
      @confirm="tipVisible = false"
    />
  </div>
</template>

<script>
import ruleModal from './components/ruleModal.vue'
import confirmModal from './components/confirmModal.vue'
import rewordModal from './components/rewordModal.vue'
import recordModal from './components/recordModal.vue'
import tipModal from './components/tipModal.vue'
import { preloadAllImages } from './components/preloadImages.js'
import {
  luyuanNewCustomerQueryActivityDetail,
  luyuanNewCustomerCheck
} from '@/api/luyuan'
export default {
  name: 'luyuanNewCustomerGift',
  components: { ruleModal, confirmModal, rewordModal, recordModal, tipModal },
  data() {
    return {
      // 权益等级JSON数据
      benefitList: [
        {
          title: '财富礼（权益六选一）',
          titleImg: require('@/assets/imgs/xibNewCustomerGift/luyuanCustomerT1.png'),
          digitalOptions: [
            {
              name: '微信立减金',
              img: `https://ydsh-prod.oss-cn-hangzhou.aliyuncs.com/20260701/luyuanCustomerWx&4104&20260701095807.png`,
              price: '38元'
            },
            {
              name: '京东E卡',
              img: `https://ydsh-prod.oss-cn-hangzhou.aliyuncs.com/20260701/luyuanCustomerJd&8113&20260701095838.png`,
              price: '38元'
            },
            {
              name: '商城积分',
              img: `https://ydsh-prod.oss-cn-hangzhou.aliyuncs.com/20260701/luyuanCustomerJf&11049&20260701095855.png`,
              price: '2400积分'
            },
            {
              name: '白鹭积分',
              img: `https://ydsh-prod.oss-cn-hangzhou.aliyuncs.com/20260701/luyuanCustomerBl&2500&20260701095912.png`,
              price: '640积分'
            }
          ],
          physicalOptions: [
            {
              name: '东北长粒香米',
              img: `https://ydsh-prod.oss-cn-hangzhou.aliyuncs.com/20260701/luyuanCustomerSw1&14154&20260701150505.png`,
              price: '中粮福临门唯粹东北长粒香米2.5KG'
            },
            {
              name: '舒客组合牙膏',
              img: `https://ydsh-prod.oss-cn-hangzhou.aliyuncs.com/20260722/luyuanCustomeryg&7791&20260722152618.png`,
              price: '舒客红花清火惠享组合4支装ZHS-HH40'
            }
          ]
        },
        {
          title: '白金礼（权益六选一）',
          titleImg: require('@/assets/imgs/xibNewCustomerGift/luyuanCustomerT2.png'),
          digitalOptions: [
            {
              name: '微信立减金',
              img: `https://ydsh-prod.oss-cn-hangzhou.aliyuncs.com/20260701/luyuanCustomerWx&4104&20260701095807.png`,
              price: '118元'
            },
            {
              name: '京东E卡',
              img: `https://ydsh-prod.oss-cn-hangzhou.aliyuncs.com/20260701/luyuanCustomerJd&8113&20260701095838.png`,
              price: '118元'
            },
            {
              name: '商城积分',
              img: `https://ydsh-prod.oss-cn-hangzhou.aliyuncs.com/20260701/luyuanCustomerJf&11049&20260701095855.png`,
              price: '6500积分'
            },
            {
              name: '白鹭积分',
              img: `https://ydsh-prod.oss-cn-hangzhou.aliyuncs.com/20260701/luyuanCustomerBl&2500&20260701095912.png`,
              price: '1700积分'
            }
          ],
          physicalOptions: [
            {
              name: '超能洗衣液',
              img: `https://ydsh-prod.oss-cn-hangzhou.aliyuncs.com/20260701/luyuanCustomerSw3&9573&20260701150514.png`,
              price: '超能自天然洗衣液香根草香3KG'
            },
            {
              name: '星巴克吸管杯',
              img: `https://ydsh-prod.oss-cn-hangzhou.aliyuncs.com/20260701/luyuanCustomerSw4&10675&20260701150518.png`,
              price: '星巴克绿野秘境清透吸管杯473ML'
            }
          ]
        },
        {
          title: '黑金礼（权益六选一）',
          titleImg: require('@/assets/imgs/xibNewCustomerGift/luyuanCustomerT3.png'),
          digitalOptions: [
            {
              name: '微信立减金',
              img: `https://ydsh-prod.oss-cn-hangzhou.aliyuncs.com/20260701/luyuanCustomerWx&4104&20260701095807.png`,
              price: '388元'
            },
            {
              name: '京东E卡',
              img: `https://ydsh-prod.oss-cn-hangzhou.aliyuncs.com/20260701/luyuanCustomerJd&8113&20260701095838.png`,
              price: '388元'
            },
            {
              name: '商城积分',
              img: `https://ydsh-prod.oss-cn-hangzhou.aliyuncs.com/20260701/luyuanCustomerJf&11049&20260701095855.png`,
              price: '23000积分'
            },
            {
              name: '白鹭积分',
              img: `https://ydsh-prod.oss-cn-hangzhou.aliyuncs.com/20260701/luyuanCustomerBl&2500&20260701095912.png`,
              price: '6100积分'
            }
          ],
          physicalOptions: [
            {
              name: '外交官拉杆箱',
              img: `https://ydsh-prod.oss-cn-hangzhou.aliyuncs.com/20260722/luyuanCustomerlg1&5147&20260722152649.png`,
              price: '外交官拉杆箱HM-61082'
            },
            {
              name: '摩飞按摩仪',
              img: `https://ydsh-prod.oss-cn-hangzhou.aliyuncs.com/20260722/luyuanCustomeramy&7594&20260722152706.png`,
              price: '摩飞头部按摩仪MF201PRO'
            }
          ]
        },
        {
          title: '私钻礼（权益六选一）',
          titleImg: require('@/assets/imgs/xibNewCustomerGift/luyuanCustomerT4.png'),
          digitalOptions: [
            {
              name: '微信立减金',
              img: `https://ydsh-prod.oss-cn-hangzhou.aliyuncs.com/20260701/luyuanCustomerWx&4104&20260701095807.png`,
              price: '588元'
            },
            {
              name: '京东E卡',
              img: `https://ydsh-prod.oss-cn-hangzhou.aliyuncs.com/20260701/luyuanCustomerJd&8113&20260701095838.png`,
              price: '588元'
            },
            {
              name: '商城积分',
              img: `https://ydsh-prod.oss-cn-hangzhou.aliyuncs.com/20260701/luyuanCustomerJf&11049&20260701095855.png`,
              price: '35000积分'
            },
            {
              name: '白鹭积分',
              img: `https://ydsh-prod.oss-cn-hangzhou.aliyuncs.com/20260701/luyuanCustomerBl&2500&20260701095912.png`,
              price: '9100积分'
            }
          ],
          physicalOptions: [
            {
              name: '摩飞炸烤箱',
              img: `https://ydsh-prod.oss-cn-hangzhou.aliyuncs.com/20260722/luyuanCustomerkx&8139&20260722152726.png`,
              price: '摩飞空气炸烤箱12升MR4014'
            },
            {
              name: '爱华仕行李箱',
              img: `https://ydsh-prod.oss-cn-hangzhou.aliyuncs.com/20260722/luyuanCustomerlg2&6221&20260722152745.png`,
              price: '爱华仕斜杠行李箱大容量拉杆箱24英寸OCX6708-24'
            }
          ]
        }
      ],
      pageLoading: true, // 页面加载状态
      // 弹框
      ruleVisible: false, // 规则弹框
      recordVisible: false, // 领取记录弹框
      confirmVisible: false, // 确认二次弹框
      confirmIsPopup: null, // 确认二次弹框月份
      rewordVisible: false, // 奖品弹框
      tipVisible: false, // 提示弹框
      tipMessage: '领取时间未开始', // 提示文案
      userRightsToken: undefined, // 校验领取token
      userRightsLevel: undefined // 校验领取等级
      // receiveStatus: undefined // 领奖状态：1可领奖，2不可参与当月达标次月领奖，3不可参与已领取奖励，4未达标，5无法参与
    }
  },
  async mounted() {
    await preloadAllImages()
    await this.luyuanNewCustomerQueryActivityDetail()
    this.pageLoading = false
  },
  methods: {
    async handleClaim(benefit) {
      try {
        if (!benefit.selectable) return
        const { code, data } = await luyuanNewCustomerCheck({})
        if (code !== 0) return
        this.userRightsToken = data.userRightsToken // 校验领取token
        this.userRightsLevel = data.level // 用户可领取等级
        // isPopup 是否弹确认弹框，返回0不弹窗
        if (data.isPopup === 0) {
          this.rewordVisible = true
          return
        }
        this.confirmIsPopup = data.isPopup
        this.confirmVisible = true
      } catch (error) {
        console.log(error)
      }
    },
    onConfirmClaim() {
      this.confirmVisible = false
      this.rewordVisible = true
    },
    async luyuanNewCustomerQueryActivityDetail() {
      try {
        const { code, data } = await luyuanNewCustomerQueryActivityDetail({})
        if (code !== 0) return
        if(!data?.activityList?.length) return
        const benefitList = this.benefitList
        benefitList.forEach((item,index) => {
          item.buttonText = data.activityList[index].buttonText
          item.level = data.activityList[index].level
          item.selectable = data.activityList[index].selectable
        })
        this.benefitList = benefitList
      } catch (error) {
        console.log(error)
      }
    },
    // 去分享
    goShare() {
      // demo展示的情况
      let param = {
        title: '财富晋升计划', //分享链接的标题
        desc: '鹭启新财·新客晋级礼，达标后最高可领取588元立减金，数量有限，先到先得',
        thumbnail: `https://elife-dev.oss-cn-shanghai.aliyuncs.com/20260727/share&69935&20260727153647.jpg`, //分享链接的图标
        url: `${process.env.VUE_APP_H5_PREFIX_URL}ydsh-ph-h5-bankv3/luyuanShare`, //分享页的链接
      }
      // eslint-disable-next-line no-undef
      XIBLS.SocialShare.shareAll(
        function () {
          console.log('分享成功')
        },
        function () {
          console.log('分享失败')
        },
        param,
      )
    }
  }
}
</script>

<style lang="less" scoped>
.new-customer-gift {
  position: relative;
  min-height: 100vh;
  background: url('~@/assets/imgs/xibNewCustomerGift/luyuanBg.png') no-repeat
      top center,
    #1b9bb5;
  background-size: 100% auto;
  padding: 420px 0 15px;
  box-sizing: border-box;
  .benefit-list {
    position: relative;
    z-index: 1;
    padding: 6px 10px 10px;
    background-color: #1b899f;
    border-radius: 15px;
    box-shadow: 0px 6px 27px 3px rgba(44, 44, 44, 0.17);
    margin: 0 15px;
    .claim-tip {
      font-size: 12px;
      color: #fff;
      text-align: center;
      margin: 15px 0 0px 0;
      span {
        color: #ff8c05;
      }
    }
    .benefit-item {
      .benefit-title-img-wrapper {
        padding-top: 14.5px;
        display: flex;
        justify-content: center;
        .benefit-title-img {
          width: 332.5px;
          height: 22px;
        }
      }

      .digital-items-grid {
        display: flex;
        gap: 10px;
        padding: 10px 0px;

        .digital-card {
          flex: 1;
          background-color: #fff;
          border-radius: 6.5px;
          box-shadow: 1px 2px 0px 0px rgba(64, 27, 132, 0.46);
          padding-bottom: 4.5px;
          position: relative;

          .card-header-tag {
            height: 22px;
            width: 62px;
            background-image: url('~@/assets/imgs/xibNewCustomerGift/luyuanTipsBg.png');
            background-size: 100% 100%;
            background-repeat: no-repeat;
            padding-left: 4px;
            font-size: 10px;
            color: #fff;
            line-height: 16px;
          }

          .card-img {
            width: 60px;
            height: 37px;
            margin: auto;
            object-fit: contain;
            display: block;
          }

          .card-price-tag {
            width: 62px;
            margin: 10px auto 0;
            background: #2f8c65;
            border-radius: 8px;
            padding: 4px 0;
            text-align: center;
            font-size: 10px;
            color: #fff;
            font-weight: bold;
          }
        }
      }

      .physical-items-grid {
        display: flex;
        gap: 11px;
        padding: 0 0px 10px;
        .physical-card {
          flex: 1;
          background-color: #fff;
          border-radius: 6.5px;
          box-shadow: 1px 2px 0px 0px rgba(64, 27, 132, 0.46);
          position: relative;

          .card-header-tag.physical-tag {
            height: 22px;
            width: 72px;
            position: absolute;
            top: 0;
            left: 0px;
            background-image: url('~@/assets/imgs/xibNewCustomerGift/luyuanTipsBg.png');
            background-size: 100% 100%;
            background-repeat: no-repeat;
            padding-left: 3px;
            font-size: 10px;
            color: #fff;
            line-height: 16px;
          }

          .physical-content {
            display: flex;
            align-items: center;
            padding: 6px 3.5px 6px 10px;

            .physical-desc {
              flex: 1;
              font-size: 8px;
              color: rgba(94, 94, 94, 1);
              font-family: FZLTHK--GBK1-0;
              line-height: 12px;
            }

            .physical-img {
              width: 66px;
              height: 61px;
              object-fit: contain;
            }
          }
        }
      }

      .claim-btn {
        margin: 6px auto 0px;
        background: url('~@/assets/imgs/xibNewCustomerGift/luyuanBtnBg.png') center center no-repeat;
        background-size: 142px 54px;
        height: 54px;
        line-height: 48px;
        cursor: pointer;
        text-align: center;
        font-size: 12px;
        color: #ffffff;
        font-weight: normal;
        font-family: DFLiJinHeiGB Std;
        text-shadow: 1px 3px 3px rgba(24, 28, 74, 0.73);
      }
    }
  }

  .benefit-info {
    position: absolute;
    right: 0;
    top: 190px;
    z-index: 22;
    .rule {
      width: 65px;
      height: 65px;
      background: url('~@/assets/imgs/xibNewCustomerGift/luyuanRuleBg.png');
      background-size: 100% 100%;
      margin-bottom: 10px;
    }
    .record {
      width: 65px;
      height: 65px;
      background: url('~@/assets/imgs/xibNewCustomerGift/luyuanRecordBg.png');
      background-size: 100% 100%;
      margin-bottom: 10px;
    }
    .share {
      width: 65px;
      height: 65px;
      background: url('~@/assets/imgs/xibNewCustomerGift/luyuanShareBg.png');
      background-size: 100% 100%;
    }
  }
}
</style>
